
var serviceUrl;
var ServiceMode = {
    "sort": 0,
    "setcontainer": 1,
    "setvisibility": 2,
    "removeContainer": 3,
    "setWidth": 4,
    "removePage": 5,
    "movePage": 6,
    "moveContainerToPage": 7,
    "copyPage": 8
};

var lastServiceMode = '';
var lastContainerStateVisible = true;
var lastContainerStateId = '';
var lastPanelWidth;
var lastPageRemoved;
var keepAliveState;

var lastContainerState = {
    Id: '',
    Visible: false
};

var lastContainerPositions = {
    topPanel: { Id: '', Containers: '' },
    leftPanel: { Id: '', Containers: '' },
    rightPanel: { Id: '', Containers: '' },
    bottomPanel: { Id: '', Containers: '' }
};

function SetContainerState(sender) {
    lastContainerStateId = $(sender).data('id');
    CallService("setvisibility=" + lastContainerStateId, ServiceMode.setvisibility, "", "", modalCallback);
}
function SetPanelWidth(width) {
    CallService("setWidth=" + width, ServiceMode.setWidth, "", "", modalCallback);
}
function KeepSessionAlive() {
    CallServiceAjax("keepalive=1", function(data){
        keepAliveState = data.Success;
    });
}

function DeleteContainerService(containerId) {
    lastContainerStateId = containerId;
    CallService("removeContainer=" + containerId, ServiceMode.removeContainer, "Container wurde gelöscht.", "Container wurde nicht gelöscht.", function (success) {
        if (success) {
            $('.box[data-id="' + lastContainerStateId + '"]').fadeOut('fast', function () {
                $(this).remove();
            });
            $('.box[data-id="' + lastContainerStateId + '"] + hr.ui-sortable-handle').fadeOut('fast', function () {
                $(this).remove();
            });
        }
    });
}

function DeletePageService(pageId) {
    lastPageRemoved = pageId;
    CallService("removePage=" + pageId, ServiceMode.removePage, "", "", modalCallback);
}

function MovePageService(pageId, parentId) {
    CallService("movePage=" + pageId + "&parentPage=" + parentId, ServiceMode.movePage, "", "", modalCallback);
}

function CopyPageService(pageId, parentId) {
    CallService("copyPage=" + pageId + "&parentPage=" + parentId, ServiceMode.copyPage, "", "", modalCallback);
}

function MoveContainerToPageService(containerId, pageId) {
    CallService("movecontainer=" + containerId + "&pageId=" + pageId, ServiceMode.moveContainerToPage, "", "", modalCallback);
}

function UpdateContainerPositions(newPositions) {
    var queryData = "setcontainer=1"
        + "&panel_" + newPositions.topPanel.Id + "=" + newPositions.topPanel.Containers
        + "&panel_" + newPositions.leftPanel.Id + "=" + newPositions.leftPanel.Containers
        + "&panel_" + newPositions.rightPanel.Id + "=" + newPositions.rightPanel.Containers
        + "&panel_" + newPositions.bottomPanel.Id + "=" + newPositions.bottomPanel.Containers;

    CallService(queryData, ServiceMode.setcontainer);
}

function RestoreState() {

    $('body').backdrop({ spinner: true, text: 'Wiederherstellung läuft...' });

    if (lastServiceMode == ServiceMode.sort) {

        CallService("sort=" + restoreSorting.replace(/&/g, "%26"), ServiceMode.sort, '', '', function (e) {
            if (e) {
                setTimeout(function () {
                    location.reload();
                }, 500);
            } else alert('Daten konnten nicht wiederhergestellt werden. Bitte ändern Sie die Reihenfolge manuell.');
        });
    }
    else if (lastServiceMode == ServiceMode.setvisibility) {
        $('.btn-hide[data-id="' + lastContainerStateId + '"]').parents('.box').toggleClass('disabled');

        CallService("setvisibility=" + lastContainerStateId, ServiceMode.setvisibility, '', '', hideStatus);
        $('body').backdropClear();
    }
    else if (lastServiceMode == ServiceMode.setcontainer) {
        var queryData = "setcontainer=1"
            + "&panel_" + lastContainerPositions.topPanel.Id + "=" + lastContainerPositions.topPanel.Containers
            + "&panel_" + lastContainerPositions.leftPanel.Id + "=" + lastContainerPositions.leftPanel.Containers
            + "&panel_" + lastContainerPositions.rightPanel.Id + "=" + lastContainerPositions.rightPanel.Containers
            + "&panel_" + lastContainerPositions.bottomPanel.Id + "=" + lastContainerPositions.bottomPanel.Containers;

        CallService(queryData, ServiceMode.setcontainer, '', '', function () {
            setTimeout(function () {
                location.reload();
            }, 500);
        });
    }
    else if (lastServiceMode == ServiceMode.setWidth) {
        CallService("setWidth=" + lastPanelWidth, ServiceMode.setWidth, '', '', function () {
            setTimeout(function () {
                location.reload();
            }, 500);
        });
    }
    else if (lastServiceMode == ServiceMode.removeContainer) {
        CallService("removeContainer=" + lastContainerStateId, ServiceMode.removeContainer, "Container wurde wiederhergestellt.", "Container wurde nicht wiederhergestellt.", function (success) {
            setTimeout(function () {
                location.reload();
            }, 500);
        });
    }
    else if (lastServiceMode == ServiceMode.removePage) {
        $('#LoaderDeleteSite').modal('hide');
        $('#LoaderDeleteSiteFinish').modal('hide');
        modalCallback = function (e) {
            if (e) {
                setTimeout(function () {
                    location.reload();
                }, 500);
            }
        }

        DeletePageService(pageId);
    }

    hideStatus();
}

function CallService(queryData, serviceModeAction, successMessage, failedMessage, callback) {
    lastServiceMode = serviceModeAction;

    CallServiceAjax(queryData, function (data) {
        if (data.Success) {
            showStatus(successMessage != undefined && successMessage.length > 0 ? successMessage : "Einstellungen wurden gespeichert.", true);
        } else {
            showStatus(failedMessage != undefined && failedMessage.length > 0 ? failedMessage : "Einstellungen wurden nicht gespeichert.", false);
        }

        if (callback != undefined && typeof callback == 'function') callback(data.Success);
    })
}

function CallServiceAjax(queryData, callback) {
    $.ajax({
        type: "POST",
        async: true,
        url: serviceUrl,
        data: queryData,
        dataType: "json",
        success: callback
    });
}
